/** @format */

import {SUBSTRATE_BLACK_VELLUM} from 'frontier-constants';

const handleDownloadFrameFile = ({frameFileKey: key, substrateId, framePageCount}, e) => {
    const url = `/admin/designs/download-design?key=${key}&bucket=${process.env.AWS_FRAMEFILE_CONTAINER}`;
    if (e.metaKey || e.ctrlKey) {
        createAndClickOpen(url, key);
    } else {
        createAndClickDownload(url, key);
        setTimeout(() => {
            // Download the leadin-out file
            const leadKey = key + '-leadinout';
            const leadinOutUrl = `/admin/designs/download-design?key=${leadKey}&bucket=${process.env.AWS_FRAMEFILE_CONTAINER}`;
            createAndClickDownload(leadinOutUrl, leadKey);
        }, 500);
    }
};

/**
 * Generic function for handling javascript downloads
 * @param href
 * @param fileName
 */
const createAndClickDownload = (href, fileName) => {
    const tmpLink = document.createElement('a');
    // tmpLink.style.display = 'none';

    document.body.appendChild(tmpLink);
    tmpLink.setAttribute('href', href);
    tmpLink.setAttribute('download', fileName);

    tmpLink.click();
    tmpLink.remove();
};

const createAndClickOpen = href => {
    const tmpLink = document.createElement('a');
    document.body.appendChild(tmpLink);
    tmpLink.setAttribute('href', href);
    tmpLink.setAttribute('target', '_blank');

    tmpLink.click();
    tmpLink.remove();
};

export {handleDownloadFrameFile, createAndClickDownload, createAndClickOpen};
